import { login } from "@/api/user";
import {
  getToken,
  setToken,
  removeToken,
  removeUserInfo,
  setUserInfo,
  getUserInfo
} from "@/utils/auth";
import { resetRouter } from "@/router";
import qs from "qs";

const getDefaultState = () => {
  const userInfo = getUserInfo() || {};
  return {
    token: getToken(),
    name: userInfo.member_name || userInfo.username || "",
    avatar: userInfo.member_avatar || "",
    isLogin: false,
    userInfo: userInfo,
    initInfo: null
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ISLOGIN: state => {
    state.isLogin = true;
  },
  SET_USER_INFO: (state, data) => {
    state.userInfo = data;
    state.avatar = data.member_avatar;
    state.name = data.member_name || data.username;
  },
  SET_INIT_INFO: (state, data) => {
    state.initInfo = data;
  }
};

const actions = {
  // user login
  login({ commit }, data) {
    return new Promise((resolve, reject) => {
      login(data)
        .then(response => {
          const { datas } = response;
          if (datas.status == 1) {
            // commit("SET_TOKEN", datas.key);
            // commit("SET_USER_INFO", datas);
            setToken(datas.key);
            setUserInfo(datas);
            commit("RESET_STATE");
            commit("SET_ISLOGIN");
          }
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 二维码登录
  qrCodeLogin({ commit }, datas) {
    return new Promise((resolve, reject) => {
      //   isComfirmLogin(datas)
      //     .then(res => {
      //       if (res.code == 200) {
      // console.log("登录", datas);
      datas.status = "1";
      setToken(datas.key);
      setUserInfo(datas);
      commit("RESET_STATE");
      commit("SET_ISLOGIN");
      resolve();
      //       }
      //       resolve(res);
      //     })
      //     .catch(error => {
      //       reject(error);
      //     });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      removeUserInfo();
      resetRouter();
      removeToken();
      commit("RESET_STATE");
      resolve();
    });
  },

  // remove token
  resetLoginStatus({ commit }) {
    return new Promise(resolve => {
      removeToken();
      removeUserInfo();
      commit("RESET_STATE");
      resolve();
    });
  },

  setLoginStatus({ commit }) {
    // commit("RESET_STATE");
    commit("SET_ISLOGIN");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js